<template>
    <div>
        <v-toolbar flat color="white">
             <v-tabs div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
        </v-toolbar>
        <div v-if="displayContents('points')">
            <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn round color="primary" class="white--text" @click="addPointModal()">Add Point Type</v-btn>
            <v-text-field v-model="pointSearch" label="Search"></v-text-field>
        </v-toolbar>
        <v-data-table
        :headers="pointHeaders"
        class="elevation-1"
        :items="points"
        style="cursor: pointer"
        :search="pointSearch"
        :rows-per-page-items="[25, 50, 100]"
      >
        <template v-slot:items="props">
           <td class="text-xs-center">
               <v-layout justify-center align-center wrap>
                  <v-icon @click="editPointModal(props.item)">edit</v-icon>
                  <v-icon @click="deletePoint(props.item)">delete</v-icon>
              </v-layout>
          </td>
          <td class="text-xs-center">
              {{props.item.name}}
          </td>
          
          <td class="text-xs-center">
              {{props.item.gisLayer.name}}
          </td>
          <td class="text-xs-center">
              {{props.item.type}}
          </td>
          <td class="text-xs-center">
              <v-icon>{{props.item.icon}}</v-icon>
          </td>
           <td class="text-xs-center">
             <v-avatar :color="props.item.colour"></v-avatar>
              <!-- <v-swatches v-model="props.item.colour"></v-swatches> -->
          </td>
        </template>
        </v-data-table>

         <v-dialog v-model="pointDialog" persistent width="750px" >
            <v-card flat color="white" height="600px">
                  <v-toolbar flat color="primary" v-if="pointItem">
                <h3 class="title white--text">{{pointItem.modalType}} Point Type</h3>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="pointDialog=false, pointItem={}">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center wrap>
                    <v-flex xs4 mx-1>
                        <v-text-field label="Name" v-model="pointItem.name"></v-text-field>
                    </v-flex>
                    
                     <v-flex xs4 mx-1>
                      <v-select :items="layers" label="Layer" v-model="pointItem.gisLayerId" item-text="name" item-value="id"></v-select>
                    </v-flex>
                    <v-flex xs4 mx-1>
                      <v-select :items="pointTypes" v-model="pointItem.type" label="Type"></v-select>
                    </v-flex>
                    <v-flex xs4 mx-1>
                      <v-swatches v-model="pointItem.colour"></v-swatches>
                    </v-flex>
                    <v-flex xs4 mx-1>
                      <v-select :items="stockItems" item-value="id" item-text="name" v-model="pointItem.stockItemId" label="Related Inventory Item" clearable></v-select>
                    </v-flex>
                    <v-flex xs4 mx-1>
                      <v-select :items="deviceMakeModels" item-value="id" item-text="name" v-model="pointItem.deviceMakeModelId" label="Related Device Model" clearable></v-select>
                    </v-flex>
                    <v-flex xs4 mx-1>
                      <v-checkbox v-model="pointItem.isTower" label="This item is a tower"></v-checkbox>
                    </v-flex>
                     <v-flex xs4 mx-1 v-if="!pointItem.isTower">
                      <v-checkbox v-model="pointItem.isSplitter" label="This item is a splitter" @change="pointItem.hasTubes=false, pointItem.isFibre=false"></v-checkbox>
                    </v-flex>

                    <v-flex xs4 mx-1 v-if="!pointItem.isTower&&pointItem.isSplitter">
                      <v-select v-if="pointItem.isSplitter" :items="splitterRatio" v-model="pointItem.numberOfConnectionsPoints" label="Number of Connections"></v-select>
                    </v-flex>
                    
                    <v-flex xs4 mx-1 v-if="!pointItem.isTower&&!pointItem.isSplitter">
                      <v-checkbox :disabled="pointItem.isSplitter" v-model="pointItem.hasTubes" label="This item has tubes"></v-checkbox>
                    </v-flex>

                    <v-flex xs4 mx-1 v-if="!pointItem.isTower&&pointItem.hasTubes">
                      <v-text-field v-if="pointItem.hasTubes" v-model="pointItem.tubes" type="number" min="0" label="Number of Tubes"></v-text-field>
                    </v-flex>
                    
                    <v-flex xs4 mx-1 v-if="!pointItem.isTower&&!pointItem.isSplitter">
                      <v-checkbox :disabled="pointItem.isSplitter" v-model="pointItem.isFibre" label="This is a fibre cable"></v-checkbox>
                    </v-flex>
                    <v-flex xs4 mx-1 v-if="pointItem.isFibre&&!pointItem.isTower">
                      <v-select :items="fibreStrands" v-model="pointItem.numberOfCores" type="number" min="0" label="Number of Fibre Cores"></v-select>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <v-select :prepend-icon="pointItem.icon" class="mx-1" label="Icon" :items="iconOptions" v-model="pointItem.icon">
                                <template v-slot:item="{ item }">
                                
                                <v-list-item-content class="text-xs-center">
                                <v-list-item-title  class="grey--text ml-3"><v-icon color="grey">{{item}}</v-icon></v-list-item-title>
                                </v-list-item-content>
                            </template>
                            </v-select>
                    </v-flex>
                    
                   
                </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-layout justify-center align-center>
                <v-btn round color="primary" class="white--text" v-if="pointItem.modalType == 'Add'&&pointItem.name&&pointItem.gisLayerId&&pointItem.type&&pointItem.icon" @click="createPoint(pointItem)">Create</v-btn>
                <v-btn round disabled v-else-if="pointItem.modalType == 'Add'">Create</v-btn>

                <v-btn round color="primary" class="white--text" v-if="pointItem.modalType == 'Edit'&&pointItem.name&&pointItem.type&&pointItem.icon" @click="updatePoint(pointItem)">Save</v-btn>
                <v-btn round disabled v-else-if="pointItem.modalType == 'Edit'">Save</v-btn>
              </v-layout>
            </v-card-actions>
            </v-card>
          
        </v-dialog>
        </div>

        <div v-if="displayContents('layers')">
            <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn round color="primary" class="white--text" @click="addLayerModal()">Add Layer</v-btn>
        </v-toolbar>
        <v-data-table
        :headers="layerHeaders"
        class="elevation-1"
        :items="layers"
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
               <v-layout justify-center align-center wrap>
                  <v-icon @click="editLayerModal(props.item)">edit</v-icon>
                  <v-icon @click="deleteLayer(props.item)">delete</v-icon>
              </v-layout>
          </td>
          <td class="text-xs-center">
              {{props.item.name}}
          </td>
          <td class="text-xs-center">
              <v-icon>{{props.item.icon}}</v-icon>
          </td>
        </template>
        </v-data-table>

        <v-dialog v-model="layerDialog" persistent width="750px">
            <v-card flat color="white">
                  <v-toolbar flat color="primary" v-if="layerItem">
                <h3 class="title white--text">{{layerItem.modalType}} Layer</h3>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="layerDialog=false, layerItem={}">X</v-btn>
            </v-toolbar>
            <v-card-text mx-1>
                <v-layout justify-center align-center wrap>
                    <v-flex xs4 mx-1>
                        <v-text-field label="Name" v-model="layerItem.name"></v-text-field>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <v-select :prepend-icon="layerItem.icon" class="mx-1" label="Icon" :items="iconOptions" v-model="layerItem.icon">
                                <template v-slot:item="{ item }">
                                
                                <v-list-item-content class="text-xs-center">
                                <v-list-item-title  class="grey--text ml-3"><v-icon color="grey">{{item}}</v-icon></v-list-item-title>
                                </v-list-item-content>
                            </template>
                            </v-select>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-layout justify-center align-center>
                <v-btn round color="primary" class="white--text" v-if="layerItem.modalType == 'Add'&&layerItem.name&&layerItem.icon" @click="createLayer(layerItem)">Create</v-btn>
                <v-btn round disabled v-else-if="layerItem.modalType == 'Add'">Create</v-btn>

                <v-btn round color="primary" class="white--text" v-if="layerItem.modalType == 'Edit'&&layerItem.name&&layerItem.icon" @click="updateLayer(layerItem)">Save</v-btn>
                <v-btn round disabled v-else-if="layerItem.modalType == 'Edit'">Save</v-btn>
              </v-layout>
            </v-card-actions>
            </v-card>
          
        </v-dialog>
        </div>
        
    </div>
</template>
<script>
import Api from '../services/Api'
import VSwatches from 'vue-swatches'
 import "vue-swatches/dist/vue-swatches.css"
export default {
   components: {
    'v-swatches': VSwatches
  },
    data(){
        return {
            activeTabName: 'points',
            deviceMakeModels: [],
            layers: [],
            layerDialog: false,
            layerItem: {},
            points: [],
            pointDialog: false,
            pointItem: {},
            pointSearch: '',
            pointTypes: ['Polygon', 'Line', 'Point'],
            splitterRatio: [2,4,8,16,32],
            fibreStrands: [1,2,4,8,12,24,48,72,96,144,288],
            splitterOptions: [2,4,8,16, 32, 64, 128],
            stockItems: [],
             iconOptions: ['offline_bolt', 'account_balance', 'contactless','home', 'language','online_prediction','polymer','offline_bolt', 'mediation', 'settings_ethernet', 'settings_input_svideo', 'swap_horizontal_circle','swap_vertical_circle', 'album', 'fiber_manual_record','5g', 'shuffle', 'call_merge', 'call_split','gesture', 'wifi_tethering', 'scatter_plot', 'nature','filter_tilt_shift', 'wb_sunny', 'shutter_speed', 'trip_origin', 'wifi', 'play_for_work', 'public', 'home', 'build', 'gavel', 'fingerprint', 'commute', 'merge_type', 'device_hub', 'flare', 'outbond', 'pending', 'reorder', 'settings_input_component', 'settings_input_hdmi', 'settings_input_antenna', 'settings_remote', 'timeline', 'track_changes', 'trending_down', 'trending_up', 'trending_flat', 'swap_calls', 'rss_feed', 'push_pin', 'location_on'],
            pointHeaders: [
                {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Layer",
          align: "center",
          value: "gisLayer.name"
        },
        {
          text: "Type",
          align: "center",
          value: "type"
        },
        {
          text: "Icon",
          align: "center",
          sortable: false
        },
        {
          text: "Colour",
          align: "center",
          sortable: false
        }
            ],
            layerHeaders: [
                {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Icon",
          align: "center",
          sortable: false
        }
            ],
            tabs: [
        { name: 'points', displayName: 'Points'},
        { name: "layers", displayName: "Layers" }]
        }
    },
    created(){
        this.getGISLayers()
        this.getGISPointTypes()
        this.getStockItems()
        this.getDeviceMakeModels()
    },
    methods: {
      getDeviceMakeModels(){
        Api().get('/deviceMakeModels').then(response=>{
          this.deviceMakeModels = response.data.filter(x=>x.isWireless)
        })
      },
      getStockItems(){
        Api().get('/stockItem').then(response=>{
          this.stockItems = response.data
        })
      },
        getGISLayers(){
      Api().get('/gisLayer').then(response=>{
        this.layers = response.data
      })
    },
    getGISPointTypes(){
      Api().get('/gisPointType').then(response=>{
        this.points = response.data
      })
    },
    addLayerModal(){
        if(this.authCreate(this.$store.state.currentRoute)){
            this.layerItem={
                modalType: 'Add',
                colour: '#99CC33'
            }
            this.layerDialog = true
        }
    },
    editLayerModal(item){
        if(this.authUpdate(this.$store.state.currentRoute)){
          this.layerItem=item
            this.layerItem.modalType='Edit'
            this.layerDialog = true
        }
    },
    deleteLayer(item){
        if(this.authDelete(this.$store.state.currentRoute)){
          confirm('Are you sure you want to delete this layer?')&&
          Api().put('/gisLayer/'+item.id,{isActive: false, isDeleted: true}).then(response=>{
        this.getGISLayers()
          })
        }
    },
    createLayer(item){
      Api().post('/gisLayer', item).then(response=>{
        this.getGISLayers()
        this.layerDialog = false
        this.layerItem={}
      })
    },
    updateLayer(item){
      Api().put('/gisLayer/'+item.id, item).then(response=>{
        this.getGISLayers()
        this.layerDialog = false
        this.layerItem={}
      })
    },
    addPointModal(){
        if(this.authCreate(this.$store.state.currentRoute)){
            this.pointItem={
                modalType: 'Add',
                colour: '#000000'
            }
            this.pointDialog = true
        }
    },
    editPointModal(item){
        if(this.authUpdate(this.$store.state.currentRoute)){
          this.pointItem=item
            this.pointItem.modalType='Edit'
            this.pointDialog = true
        }
    },
    deletePoint(item){
        if(this.authDelete(this.$store.state.currentRoute)){
          confirm('Are you sure you want to delete this layer?')&&
          Api().put('/gisPointType/'+item.id,{isActive: false, isDeleted: true}).then(response=>{
        this.getGISPointTypes()
          })
        }
    },
    createPoint(item){
      Api().post('/gisPointType', item).then(response=>{
        this.getGISPointTypes()
        this.pointDialog = false
        this.pointItem={}
      })
    },
    updatePoint(item){
      Api().put('/gisPointType/'+item.id, item).then(response=>{
        this.getGISPointTypes()
        this.pointDialog = false
        this.pointItem={}
      })
    },
        displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) { 
      this.activeTabName = name;
    },
    }
}
</script>